import { get } from 'lodash-es'
import { formatPics, filterParams } from '@/common/utils/format'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'

// 对后端接口下发的数据做格式转换
export function revert (data = {}) {
  const corp = get(data, 'bizGlobal.docInfo.corp')
  if (!corp) return {}
  return {
    // notaryDate: formatDate(corp.notaryDate),
    licensePics: formatPics(corp.licensePics),
    files: formatPics(corp.files)
  }
}

export function submitFormat (companyInfo) {
  return {
    params: JSON.stringify({
      source: 'contractor',
      queryId: this.$route.params.id,
      bizGlobal: {
        ...companyInfo.bizGlobal,
        country: country
      }
    })
  }
}

export default {
  revert,
  submitFormat
}
